export default vue => ({
  dataSource: [
    { id: 'pending', name: vue.$t('pending') },
    { id: 'uploaded', name: vue.$t('uploaded') },
    { id: 'rejected', name: vue.$t('rejected') },
    { id: 'accepted', name: vue.$t('accepted') },
    { id: 'withdraw', name: vue.$t('withdraw') },
    { id: 'withdrawn', name: vue.$t('withdrawn') },
    { id: 'processing_error', name: vue.$t('processing error') },
  ],
  valueExpr: 'id',
  displayExpr: 'name',
});
